// Copyright 2016 Sorama B.V.

import { Disposable } from "aurelia-binding";
import { RouterConfiguration } from "aurelia-router";
import { User } from "oidc-client";

export abstract class IAuthentication {
    public readonly isSignedIn: boolean;

    public readonly userId: string;
    public readonly userName: string;
    public readonly businessUnitId: string;

    public abstract getUser(): Promise<User>;
    public abstract configure(router: RouterConfiguration): Promise<void>;

    public abstract signIn(): Promise<void>;
    public abstract signOut(): Promise<void>;

    public abstract addAuthenticationHandler(handler: IAuthenticationHandler): Disposable;
}

export interface IAuthenticationHandler {
    onSignIn(userId: string): Promise<void>;
    onSignOut(): Promise<void>;
}
